// extracted by mini-css-extract-plugin
export default {"signup-wrapper":"Signup_signup-wrapper__qBC+H"};